import { FileCopy } from '@mui/icons-material'
import { useSelector } from 'react-redux'

import { useCopyOrdersModal } from '@/components/modals/CopyOrdersModal'
import { Container } from '@/components/primitives/ControlStrip'
import { Tooltip } from '@/components/primitives/Tooltip'
import { IconButton } from '@/components/primitives/buttons'
import { selectOrderStepIdsInRange } from '@/features/domain/order'
import { useTexts } from '../useTexts'

interface Props {
  userType: uui.domain.rm.RouteManagerUserType
}

export function ArchivedControls(props: Props) {
  const { show: showCopyOrdersModal, Modal: CopyOrdersModal } = useCopyOrdersModal()
  const orderStepIdsInRange = useSelector(selectOrderStepIdsInRange)
  const texts = useTexts()

  const disableCopy = Object.keys(orderStepIdsInRange).length === 0
  const { userType } = props

  const readOnlyUser = ['viewer', 'courier', 'guest'].includes(userType)

  if (readOnlyUser) return null

  return (
    <Container>
      <Tooltip
        title={disableCopy ? texts.emptyArchivedDayTitle : texts.copy}
        subtitle={disableCopy ? texts.emptyArchivedDaySubtitle : undefined}
        placement="top"
      >
        <IconButton onClick={showCopyOrdersModal} disabled={disableCopy} style={{ color: 'white' }}>
          <FileCopy fontSize="small" color="inherit" />
        </IconButton>
      </Tooltip>

      <CopyOrdersModal />
    </Container>
  )
}
